var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon10Volt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 6,
    fill: "#6C2773"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2676 47.1757C55.7111 38.7322 55.7111 25.0628 47.2676 16.6409",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.733 16.6409C8.28952 25.0844 8.28952 38.7538 16.733 47.1757",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 52.2288C27.1837 53.0278 29.5806 53.4166 31.9992 53.4166C34.4178 53.395 36.8148 53.0278 39.1254 52.2288",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 11.5878C27.1837 10.7888 29.5806 10.4 31.9992 10.4C34.4178 10.4 36.8148 10.7888 39.1254 11.5878",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2223 18.1519H44.9824V24.6313C44.9824 26.1432 45.7953 26.4492 46.7868 25.3153L53.5486 17.5759C54.3793 16.631 54.0309 15.8481 52.7714 15.8481H50.0113V9.36867C50.0113 7.8568 49.1985 7.55083 48.207 8.68473L41.4452 16.424C40.6234 17.378 40.9718 18.1519 42.2223 18.1519Z",
    fill: "#F7E237"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7946 39V25.8L20.6546 26.74H16.6346V25H21.7746V39H19.7946ZM30.557 39.16C29.4636 39.16 28.4836 38.88 27.617 38.32C26.7636 37.76 26.0836 36.9467 25.577 35.88C25.0836 34.8133 24.837 33.52 24.837 32C24.837 30.48 25.0836 29.1867 25.577 28.12C26.0836 27.0533 26.7636 26.24 27.617 25.68C28.4836 25.12 29.4636 24.84 30.557 24.84C31.637 24.84 32.6103 25.12 33.477 25.68C34.3436 26.24 35.0236 27.0533 35.517 28.12C36.0103 29.1867 36.257 30.48 36.257 32C36.257 33.52 36.0103 34.8133 35.517 35.88C35.0236 36.9467 34.3436 37.76 33.477 38.32C32.6103 38.88 31.637 39.16 30.557 39.16ZM30.557 37.38C31.2903 37.38 31.9303 37.18 32.477 36.78C33.037 36.38 33.4703 35.78 33.777 34.98C34.097 34.18 34.257 33.1867 34.257 32C34.257 30.8133 34.097 29.82 33.777 29.02C33.4703 28.22 33.037 27.62 32.477 27.22C31.9303 26.82 31.2903 26.62 30.557 26.62C29.8236 26.62 29.177 26.82 28.617 27.22C28.057 27.62 27.617 28.22 27.297 29.02C26.9903 29.82 26.837 30.8133 26.837 32C26.837 33.1867 26.9903 34.18 27.297 34.98C27.617 35.78 28.057 36.38 28.617 36.78C29.177 37.18 29.8236 37.38 30.557 37.38ZM41.9535 39L37.3135 28.4H39.3135L43.4335 38H42.4735L46.6735 28.4H48.5535L43.9135 39H41.9535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10Volt);
export default __webpack_public_path__ + "static/media/icon_10volt.c175fb144086430a6c17c6921a8411d0.svg";
export { ForwardRef as ReactComponent };